import { render } from "./Mobile.vue?vue&type=template&id=3c1ca2ca&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"

import "./Mobile.vue?vue&type=style&index=0&id=3c1ca2ca&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1ca2ca"]])

export default __exports__